<div
	class="dropdown {{ dropdownContainerClass }}"
	ngbDropdown
	[autoClose]="'outside'"
	display="dynamic"
>
	<button
		ngbDropdownToggle
		[ngbTooltip]="tooltip"
		display="dynamic"
		class="e2e_dropdown_select_toggle btn dropdown-toggle {{ dropdownToggleClass }}"
		type="button"
		id="dropdownMenuButton"
		data-toggle="dropdown"
		aria-haspopup="true"
		aria-expanded="false"
	>
		{{ label$ | async }}
	</button>
	<div
		#dropdownMenu
		ngbDropdownMenu
		class="dropdown-menu overflow-auto {{ dropdownMenuClass }}"
		[style.max-height]="'calc(100vh - ' + (top$ | async) + 'px)'"
		aria-labelledby="dropdownMenuButton"
	>
		<ng-container *ngFor="let option of options">
			<button
				(click)="toggleOption(control, options, option)"
				ngbDropdownItem
				class="dropdown-item {{ dropdownItemClass }} d-flex flex-row pl-0"
				[class.active]="isCurrentOption(option)"
				role="button"
			>
				{{ option.value }}
			</button>
		</ng-container>
		<div *ngIf="multiple" class="dropdown-divider"></div>
		<button
			*ngIf="multiple"
			(click)="toggleOption(control, options, null)"
			ngbDropdownItem
			class="dropdown-item {{ dropdownItemAllClass }} d-flex flex-row pl-0"
			[class.active]="control.value.length === options.length"
		>
			All
		</button>
	</div>
</div>
